import { ServiceTypeModel } from "../../../entities";
import { BaseODataRepository } from "../../BaseODataRepository";

export class ServiceTypeODataRepo extends BaseODataRepository<ServiceTypeModel> {
  protected baseUrl = `/OData/servicetypes`;
}
